import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { ConvertableCurrencyListModel } from '@/models/ps-management/currency-converter.model';

export default class GetConvertableCurrencyListRequest extends ApiResourceMethod<ConvertableCurrencyListModel> {
  public perform(): Promise<ConvertableCurrencyListModel> {
    return this.performer.requestWithMapper(
      {},
      ({ data }: BaseResponse<ConvertableCurrencyListModel>) => data,
    );
  }
}
